import { render } from "./index.vue?vue&type=template&id=f6f7a4d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f6f7a4d2&lang=scss&scoped=true"

import exportComponent from "E:\\06film\\web\\film-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f7a4d2"]])

export default __exports__